<template>
  <div>
    <div class="sp_view">
      <div class="leftbox">
        <div class="lbox">
          <div class="tit">
            <span>企业标签组</span>
            <el-button type="primary" size="mini" @click="updatacrop">刷新</el-button>
            <i class="el-icon-plus add" @click="labelbtn()" />
          </div>
          <div v-for="(item,index) in tableData" :key="index" class="labellist">
            <div class="tablebox">
              <div class="groupbox">
                <div class="group" @click="groupName(index)">
                  <svg-icon icon-class="more" />
                  <i v-if="ind===index && down" class=" el-icon-caret-bottom" />
                  <i v-else class="el-icon-caret-right" />
                  <p class="groupname">

                    {{ item.group_name }}
                  </p>
                </div>
                <div>
                  <i class="el-icon-edit" style="margin-right: 5px;cursor: pointer" @click="edit(item)" />
                  <i class="el-icon-delete" style="cursor: pointer" @click="delgroup(item)" />
                </div>
              </div>

              <div v-if="ind===index && down">
                <div v-for="(it,inds) in item.children" :key="inds" class="labelname" :class="{active:isactive&&tag_id===it.tag_id}" @click="selectlabel(it,inds)">
                  <div class="tagbox">
                    <svg-icon icon-class="more" />
                    <p class="tagname">{{ it.tag_name }}</p>
                  </div>

                  <i class="el-icon-close" style="margin-right: 10px;cursor: pointer" @click.stop="deltag(it,item)" />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="rightbox">

        <div class="tabselecr_box">
          <div class="search_box">
            <el-input
              v-model="query.employee"
              clearable
              style="width:300px"
              placeholder="员工的编号/姓名"
            />
            <el-input
              v-model="query.customer"
              clearable
              style="width:300px;"
              placeholder="客户备注名称/客户id"
            />
            <el-select v-model="query.onlyMe" placeholder="请选择" style="width:200px">
              <el-option
                v-for="item in accountarr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchclick"
            >搜索</el-button>
            <el-button
              type="info"
              icon="el-icon-refresh-right"
              @click="rechargeclick"
            >重置</el-button>
          </div>
          <div>
            <el-button type="success" icon="el-icon-plus" @click="add">添加客户</el-button>
          </div>
        </div>
        <el-table ref="multipleTable" :data="listData" border size="100%" :row-key="val => val.id" @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55"
          />
          <el-table-column
            prop="remark"
            label="客户昵称"
            align="center"
          />
          <el-table-column
            prop="avatar"
            label="客户头像"
            align="center"
          >
            <template slot-scope="scope">
              <img :src="scope.row.avatar" alt="" style="width: 60px;height: 60px;">
            </template>
          </el-table-column>
          <el-table-column
            prop="external_user_id"
            label="外部客户id"
            align="center"
            width="300"
          />
          <el-table-column
            prop="employee_name"
            label="归属员工"
            align="center"
          />
          <el-table-column
            prop="employee_no"
            label="员工编号"
            align="center"
            width="260"
          />

          <el-table-column
            prop="corp_name"
            label="企业名称"
            align="center"
          />
          <el-table-column
            prop="tag_name"
            label="标签"
            align="center"
          />

          <el-table-column
            prop="created_at_text"
            label="添加时间"
            align="center"
            width="170"
          />
          <el-table-column
            fixed="right"
            label="操作"
            width="110"
          >
            <template scope="scope">
              <el-button type="primary" size="small" @click="editLabel(scope.row)">修改标签</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination-right
          :current-page="query.page"
          :total="total"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />

      </div>

    </div>
    <el-dialog
      title="添加标签组"
      :visible.sync="labeldialogstatus"
      :append-to-body="true"
      :destroy-on-close="true"
      width="35%"
    >
      <labelVue ref="labeldialogview" @updatlabel="updatlabel" />
    </el-dialog>
    <el-dialog
      title="编辑标签组"
      :visible.sync="editdialogstatus"
      :append-to-body="true"
      :destroy-on-close="true"
      width="35%"
      @close="closeEdit"
    >
      <editLabelVue ref="editdialogview" @editlabel="editlabel" />
    </el-dialog>
    <el-dialog
      title="添加客户"
      :visible.sync="adddialogstatus"
      :append-to-body="true"
      :destroy-on-close="true"

      width="70%"
    >
      <addCustomVue ref="adddialogview" @addcustom="addcustom" />
    </el-dialog>
    <el-dialog
      title="修改标签"
      :visible.sync="labeldialog"
      :append-to-body="true"
      :destroy-on-close="true"
      width="1000px"
    >
      <sonEditLabel ref="editlabel" :group-label="closegroupLabel" />
    </el-dialog>
  </div>

</template>

<script>
import labelVue from './label.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import editLabelVue from './editLabel.vue'
import sonEditLabel from './sonEditLabel.vue'
import { corpTag, corpTagExternalList, delCorpTag, delCorpGroup, refreshTag } from '@/api/numberTemplatemessage'
import addCustomVue from './addCustom.vue'
export default {
  // name: 'Label',
  components: {
    PaginationRight,
    labelVue,
    editLabelVue,
    addCustomVue,
    sonEditLabel
  },
  data() {
    return {
      activeName: 'chat',
      input: '',
      input2: '',
      query: {
        page: 1,
        pageSize: 10,
        employee: '',
        customer: '',
        onlyMe: 2
      },
      total: null,
      tableData: [],
      ind: null,
      down: false,
      show: false,
      listData: [],
      labeldialogstatus: false,
      labeldialog: false,
      editdialogstatus: false,
      corp_id: [],
      isactive: false,
      indexs: null,
      selectind: null,
      adddialogstatus: false,
      tag_id: '',
      group_id: '',
      tagid: '',
      groupid: '',
      accountarr: [{
        value: 1,
        label: '组内的标签'
      }, {
        value: 2,
        label: '我关联的标签'
      }],
      deltagid: null,
      tagName: null
    }
  },
  watch: {
    '$route.query.id': {
      handler(newVal, oldVal) {
        // 判断newVal有没有值监听路由变化
        console.log('$route.query.id', newVal, oldVal)
        if (newVal) {
          this.corp_id = []
          this.corp_id.push(this.$route.query.id)
          // this.corp_id = this.$route.query.id
          console.log('this.corp_id-----------watch', this.corp_id)
          this.id = this.$route.query.id
          console.log('this.-----------watch', this.id)
          this.tag_id = ''
          this.listData = []
          // this.groupLabel()
        }
      },
      deep: true
    }
  },
  created() {
    this.corp_id.push(this.$route.query.id)
    // this.corp_id = this.$route.query.id
    console.log('this.corp_id---creat', this.corp_id)
    this.id = this.$route.query.id
    this.groupLabel()
  },
  mounted() {
  },
  activated() {
    this.groupLabel()
  },
  methods: {
    closegroupLabel() {
      this.labeldialog = false
      this.groupLabel()
    },
    editLabel(row) {
      this.labeldialog = true
      this.$nextTick(() => {
        this.$refs.editlabel.sendr(row, this.corp_id)
      })
    },
    // 标签组
    async groupLabel() {
      console.log('this.corp_id----')
      const labelData = await corpTag({ corp_id: this.corp_id })
      console.log('labelData', labelData)
      this.tableData = labelData.data[0].children
      console.log('this.tableData---', this.tableData)
    },
    // 标签组
    async updatagroupLabel() {
      // console.log('this.corp_id----')
      const labelData = await refreshTag({ corp_id: this.corp_id[0] })
      console.log('labelData', labelData)
      this.groupLabel()
      // this.tableData = labelData.data[0].children
      // console.log('this.tableData---', this.tableData)
    },
    updatacrop() {
      this.updatagroupLabel()
    },
    // 客户信息
    async list() {
      const data = await corpTagExternalList({
        tag_id: this.tag_id,
        page: this.query.page,
        page_size: this.query.pageSize,
        staff_keyword: this.query.employee,
        follow_keyword: this.query.customer,
        onlyMe: this.query.onlyMe,
        corp_id: this.id
      })
      if (!data || !data.data) {
        this.$message.error('服务器请求失败，请稍后重试')
        return
      }
      if (data.data === null) {
        this.listData = []
        this.total = null
        return
      }
      this.listData = data.data.list
      this.total = data.data.total
      console.log('this.listData', this.listData)
    },
    // 选择的标签组
    groupName(index) {
      this.selectind = null
      this.ind = index
      this.show = !this.show
      this.down = !this.down
      if (this.down === true) {
        this.isactive = true
      }
    },
    // 选择标签
    selectlabel(it, ind) {
      this.selectind = ind
      this.tag_id = it.tag_id
      this.tagName = it.tag_name
      this.query.page = 1
      this.list()
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    // 搜索
    searchclick() {
      this.query.page = 1
      this.list()
    },
    // 重置
    rechargeclick() {
      this.query.page = 1
      this.query.employee = null
      this.query.customer = null
      this.list()
    },
    // 添加标签组
    labelbtn() {
      this.labeldialogstatus = true
      // console.log('企业标签', row)
      // this.$nextTick(() => {
      //   this.$refs.labeldialogview.send(row)
      // })
    },
    updatlabel() {
      this.labeldialogstatus = false
      // this.list()
      this.groupLabel()
    },
    // 编辑
    edit(item) {
      this.editdialogstatus = true
      console.log('edit', item)
      this.$nextTick(() => {
        this.$refs.editdialogview.send(JSON.parse(JSON.stringify(item)))
      })
    },
    // 删除标签组
    async delgroup(item) {
      console.log('delgroup', item)
      console.log('delgroup id', this.id)
      this.group_id = item.group_id
      this.$confirm(this.$t('确认要删除标签组？删除标签组后，该标签组下所有标签对应客户将取消'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning'
      }).then(async() => {
        const data = await delCorpGroup({
          corp_id: this.id,
          group_id: this.group_id
        })
        console.log('delgroup', data)
        if (data.code === 200) {
          this.$message.success('标签组删除成功')
          this.groupLabel()
          if (this.tag_id !== '') {
            this.list()
          }
        } else {
          this.$message.error('标签组删除失败')
        }
      }).catch(() => {

      })
    },
    // 删除标签
    async deltag(it, item) {
      console.log('deltag', it, item)
      // this.tagid = it.tag_id
      this.deltagid = it.tag_id
      this.groupid = item.group_id
      this.$confirm(this.$t('确认要删除标签？删除标签后，该标签下所有客户将取消此标签'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning'
      }).then(async() => {
        const data = await delCorpTag({
          corp_id: this.id,
          group_id: this.groupid,
          tag_id: this.deltagid
        })
        if (data.code === 200) {
          this.$message.success('标签删除成功')
          this.groupLabel()
          // this.list()
          if (this.tagid === this.deltagid) {
            this.listData = []
          }
        } else {
          this.$message.error('标签删除失败')
        }
      }).catch(() => {

      })
    },
    // 编辑标签组
    editlabel() {
      console.log('editlabel')
      this.editdialogstatus = false
      // this.$nextTick(() => {
      this.groupLabel()
      if (this.tag_id === '') {
        return
      }
      this.list()
      // })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 添加客户
    addcustom() {
      this.adddialogstatus = false
      this.groupLabel()
      this.list()
    },
    add() {
      if (this.tag_id === '') {
        this.$message.warning('请先选择标签')
        return
      }
      this.adddialogstatus = true
      this.$nextTick(() => {
        this.$refs.adddialogview.send(this.tag_id, this.tagName)
      })
    },
    closeEdit() {
      this.groupLabel()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sp_view{
  width: 100%;
  /* height: 100vh; */
  display: flex;
  justify-content: left;
}
.leftbox{
  min-width: 320px !important;
  height: 90vh;
  background-color: #e7e7e7;
}
.lbox{
  height: 98%;
  margin: 10px;
  padding:5px;
  background: white;
  overflow-y: scroll;
}
.add{
  /* font-size: 22px; */
  margin-left: 30px;
  cursor: pointer
}
.tit{
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* font-size: 22px; */
  margin-bottom: 15px;
  padding:10px 10px 0 ;
}
.labellist{

  /* font-size: 18px; */
  line-height: 26px;
  margin-left: 10px;
}
/* .tablebox{
  margin-bottom: 10px;
} */
.groupbox{

  display: flex;
  justify-content: space-between;
  align-items: center;
}
.group{
  display: flex;
  justify-content: left;
  align-items: center;
  cursor: pointer
}
.groupname{
  width: 150px;
  overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;

}
.labelname{
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* font-size: 16px; */
  padding-left:20px;
 cursor: pointer
}
.rightbox{
  margin-left:10px;
  width: 81%;
  background: white;
  /* background-color: #e7e7e7; */
  padding: 15px 10px;
}
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.qr_box {
  text-align: center;
}
.tagname{
  width: 140px;
  overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
  margin-left: 15px;
}
.tagbox{
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.active{
  background: rgb(120, 199, 245);
  opacity: 0.5;
}
@media (max-width: 768px){
  .sp_view{
    flex-direction:column;
  }
  .lboxm,.leftbox{
    height:60%;
  }
  .rightbox{
    width:95vw;
  }
}
</style>
